export default __webpack_public_path__ + "fa9ccffdc41117c7e7812f34ff0bdb32.png";